import { render, staticRenderFns } from "./NSection.vue?vue&type=template&id=6a0436dc&scoped=true&"
import script from "./NSection.vue?vue&type=script&lang=js&"
export * from "./NSection.vue?vue&type=script&lang=js&"
import style0 from "./NSection.vue?vue&type=style&index=0&id=6a0436dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0436dc",
  null
  
)

export default component.exports